'use strict'

import axios from 'axios'
import delayInterceptor from './interceptor/http-delay-interceptor'
import responseInterceptor from '@/app/service/api/http/interceptor/http-response-interceptor'

const DEFAULT_TIMEOUT = 30000
const DEFAULT_ATTEMPT_COUNT = 1
const DEFAULT_ATTEMPT_PAUSE = 5000

export default class {
  constructor(address) {
    this.address = address
    this.timeout = DEFAULT_TIMEOUT
    this.attemptCount = DEFAULT_ATTEMPT_COUNT
    this.attemptPause = DEFAULT_ATTEMPT_PAUSE
    this.instance = axios.create({
      baseURL: `${address}`,
      timeout: this.timeout
    })
  }

  addRequestInterceptor(interceptor) {
    this.instance.interceptors.request.use(interceptor)
  }

  addResponseInterceptor(response, errorInterceptor) {
    this.instance.interceptors.response.use(response, errorInterceptor)
  }

  _addDelayInterceptor(serverHeader) {
    const interceptor = delayInterceptor(
      this.instance,
      {
        retries: this.attemptCount,
        delay: this.attemptPause
      },
      serverHeader)
    this.addResponseInterceptor(null, interceptor)
  }

  addDefaultInterceptors() {
    this.addResponseInterceptor(responseInterceptor())
    this._addDelayInterceptor()
  }

  toString() {
    return 'HttpClient{' +
      'address=' + '\'' + this.address + '\'' +
      ', timeout=' + this.timeout +
      ', attemptCount=' + this.attemptCount +
      ', attemptPause=' + this.attemptPause +
      '}'
  }
}
